import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export function getLandingHeroVisualStyles(theme: Theme) {
  return StyleSheet.create({
    visual: {
      flex: Platform.OS === 'web' ? 1 : undefined,
      alignItems: 'center',
      position: 'relative',
      minHeight: Platform.OS === 'web' ? 480 : 300,
    },
    visualStacked: {
      width: '100%',
      maxWidth: 520,
      alignSelf: 'center',
      minHeight: 420,
      marginTop: 56,
    },
    visualPhone: {
      maxWidth: 340,
      minHeight: 315,
      marginTop: 80,
    },
    mascotGlow: {
      position: 'absolute',
      top: '50%' as unknown as number,
      left: '50%' as unknown as number,
      width: 360,
      height: 360,
      borderRadius: 180,
      backgroundColor: theme.primary + '2E',
      transform: [{ translateX: -180 }, { translateY: -180 }],
    },
    mascotGlowPhone: {
      width: 300,
      height: 300,
      borderRadius: 150,
      transform: [{ translateX: -150 }, { translateY: -150 }],
    },
    mascotImage: {
      width: Platform.OS === 'web' ? 400 : 260,
      height: Platform.OS === 'web' ? 400 : 260,
      borderRadius: 24,
    },
    mascotImageStacked: {
      width: 340,
      height: 340,
    },
    mascotImagePhone: {
      width: 250,
      height: 250,
      borderRadius: 22,
    },
    mascotWrap: {
      alignItems: 'center',
    },
    mascotWrapPhone: {
      marginTop: 14,
    },
    floatCard: {
      position: 'absolute',
      backgroundColor: theme.background.cardElevated,
      borderRadius: 14,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.gray[300],
      paddingVertical: 10,
      paddingHorizontal: 14,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
      shadowColor: theme.primaryDark,
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: 0.22,
      shadowRadius: 20,
      elevation: 8,
    },
    floatCardPhone: {
      paddingVertical: 8,
      paddingHorizontal: 10,
      gap: 8,
      maxWidth: 190,
    },
    floatCard1: {
      top: 40,
      left: Platform.OS === 'web' ? -40 : -20,
    },
    floatCard1Phone: {
      top: 18,
      left: 0,
    },
    floatCard2: {
      bottom: Platform.OS === 'web' ? 140 : 60,
      right: Platform.OS === 'web' ? -20 : -10,
    },
    floatCard2Phone: {
      bottom: 82,
      right: 0,
    },
    floatCard3: {
      bottom: Platform.OS === 'web' ? 40 : 10,
      left: Platform.OS === 'web' ? -30 : -15,
    },
    floatCard3Phone: {
      bottom: 10,
      left: 8,
    },
    floatCardIcon: {
      width: 32,
      height: 32,
      borderRadius: 8,
      alignItems: 'center',
      justifyContent: 'center',
    },
    fcIconWin: {
      backgroundColor: theme.secondary + '26',
    },
    fcIconCoin: {
      backgroundColor: theme.accentDark + '26',
    },
    fcIconBolt: {
      backgroundColor: theme.primary + '1F',
    },
    floatCardStrong: {
      fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[900],
    },
    floatCardSpan: {
      fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
      fontSize: 12,
      color: theme.gray[600],
    },
  })
}
